import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, Signal, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { Store } from '@ngxs/store';
import { FileModel, GridDocumentModel } from '../file-manager-state/file-manager.model';
import { FileManagerState } from '../file-manager-state/file-manager.state';
import { FileDetailsComponent } from "../file-details/file-details.component";
import { FileManagerActions } from '../file-manager-state/file-manager.actions';
import { MatDialogRef } from '@angular/material/dialog';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { OnCanCloseDialog } from 'app/modules/shared-state/shared.actions';
import { SharedState } from 'app/modules/shared-state/shared.state';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-view',
    imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule, MatSidenavModule, FileDetailsComponent, FileUploadComponent],
    templateUrl: './file-view.component.html',
    styleUrl: './file-view.component.scss',
})
export class FileViewComponent implements OnInit {
    @ViewChild('matDrawer', { static: true }) matDrawer: MatDrawer;
    @ViewChild('matDrawer2', { static: true }) matDrawer2: MatDrawer;
    drawerMode: 'side' | 'over';
    drawerOpened = false;
    private _store = inject(Store);
    private _dialogRef = inject(MatDialogRef<FileViewComponent>);
    private _canCloseDialog$: Observable<boolean> = this._store.select(SharedState.getCanCloseDialog);

    public allFiles: Signal<FileModel[]> = this._store.selectSignal(FileManagerState.getAllFiles);
    public fileDetailsDrawerState: Signal<boolean> = this._store.selectSignal(FileManagerState.getFileDetailsDrawerState);
    public fileUploadDrawerState: Signal<boolean> = this._store.selectSignal(FileManagerState.getFileUploadDrawerState);
    public gridDocument: Signal<GridDocumentModel> = this._store.selectSignal(FileManagerState.getGridDocument);


    ngOnInit(): void {
        this._canCloseDialog$.subscribe((canCloseDialog) => {
            if (canCloseDialog) {
                this.onClose();
            }
        });
    }

    onFileClicked(file: FileModel) {
        if (this.matDrawer) {
            this.matDrawer.open();
        }
        this._store.dispatch(new FileManagerActions.SetSelectedFile(file));
        this._store.dispatch(new FileManagerActions.SetFileDetailsDrawerState(true));
    }

    onBackdropClicked(): void {
        if (this.fileUploadDrawerState()) {
            this._store.dispatch(new FileManagerActions.SetFileUploadDrawerState(false));
            setTimeout(() => {
                this._store.dispatch(new FileManagerActions.GetFiles());
            }, 100);
        }

        if (this.fileDetailsDrawerState()) {
            this._store.dispatch(new FileManagerActions.SetFileDetailsDrawerState(false));
        }
    }

    onClose() {
        this._dialogRef.close();
        this._store.dispatch(new FileManagerActions.SetFileDetailsDrawerState(false));
        this._store.dispatch(new OnCanCloseDialog(false));

    }

    onUploadFile() {
        // // console.log('upload file button')
        // this._popup.open(FileUploadComponent, { 
        //     width: '50%', 
        //     height: '50%' ,
        //     disableClose: false
        // });
        this._store.dispatch(new FileManagerActions.SetFileUploadDrawerState(true));

    }

    onCloseUpload() {
        this._dialogRef.close();
        this._store.dispatch(new FileManagerActions.SetFileUploadDrawerState(false));
        this._store.dispatch(new OnCanCloseDialog(false));


    }


}
